import { Box, Modal, Typography } from '@mui/material'
import styles from './modalStyle.module.scss'
const CommonModal = ({
	heading,
	subHeading,
	className,
	handleOpen,
	handleClose,
	footerContent,
	children,
	open,
	modalBody,
	modalInner,
	page,
	headerIcon,
	Chip,
	subclass=false,
	zIndex,
	...rest
}) => {
	const style = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: page === 'planner-payments' ? '740px !important' : 'auto',
	}
	return (
		<>
			<div>
				<Modal
					open={open}
					onClose={handleClose}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
					className={`${styles.modalWrp} ${className}`}
					{...(zIndex != null ? { sx: { zIndex } } : {})}
				>
					<Box
						sx={style}
						className={`${styles.modalInner} ${modalInner}`}
						{...rest}
					>
						<div
							className={`${styles.modalHeader} ${headerIcon ? styles.modalHeaderCentered : ''}`}
						>
							{headerIcon && (
								<div className={styles.modalHeaderIcon}>{headerIcon}</div>
							)}
							{!Chip &&(<Typography variant="h2">{heading}</Typography>)}
							{Chip && (
								<div className={styles.modalHeaderChip}>
									<Typography variant="h2">{heading}</Typography>
									{Chip}
								</div>
							)}
							{subHeading && (
								<Typography className={subclass?styles.subHeading:""}>{subHeading}</Typography>
							)}
							<div
								className={`${styles.closeIcon}`}
								onClick={handleClose}
							>
								<img src="/images/modal-close-icon.svg" alt="" />
							</div>
						</div>

						<div className={`${styles.modalBody} ${modalBody}`}>
							{children}
						</div>
						<div className={`${styles.modalFooter}`}>
							{footerContent}
						</div>
					</Box>
				</Modal>
			</div>
		</>
	)
}

export default CommonModal
